<template>
  <section class="position-relative">
    <div class="bg-element text-element">
      &lt;{{ bgTitle }}/&gt;
    </div>
    <div class="container">
      <div class="row justify-content">
        <div class="col-sm-6 col-md-4 mb-4">
          <h2 class="h1 font-gradient mb-4 mb-lg-5">Education</h2>
          <ul class="list-group list-group-style-1">
            <li class="list-group-item">
              <h5 class="h5 font-gradient">FINKI</h5>
              Faculty of Computer Science and Engineering,<br/>"Ss. Cyril and Methodius" University - Skopje
            </li>
          </ul>
        </div>
        <div class="col-sm-6 col-md-4 mb-4 text-md-center">
          <h2 class="h1 font-gradient mb-4 mb-lg-5">Experience</h2>
          <ul class="list-group list-group-style-1">
            <li class="list-group-item">
              <h5 class="h5 font-gradient mb-1">Kara5: Lead Web Developer</h5>
              <small>Jun 2015 - Nov 2021</small>
            </li>
            <li class="list-group-item">
              <h5 class="h5 font-gradient mb-1">TestDevLab: Software Developer</h5>
              <small>Nov 2021 - Present</small>
            </li>
          </ul>
        </div>
        <div class="col-sm-6 col-md-4 mb-4 text-md-end">
          <h2 class="h1 font-gradient mb-4 mb-lg-5">Conferences</h2>
          <ul class="list-group list-group-style-1">
            <li class="list-group-item">
              <h5 class="h5 font-gradient mb-1">Balkan Hackaton 2018</h5>
              <small>by Sofia Development Association - 2018</small>
            </li>
            <li class="list-group-item">
              <h5 class="h5 font-gradient mb-1">Kindhack Skopje 2019</h5>
              <small>by Symphony Solutions - 2019</small>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'ResumeComponent',
  data () {
    return {
      bgTitle: 'Resume',
    }
  }
}
</script>
